import React, { useCallback } from 'react';
import { useHistory } from 'react-router';

import { Collapse, SvgIcon } from '@mui/material';

import { useMenuContext } from 'pages/layout/components/MenuContext';

import useStyles from './styles';

interface Props {
    icon: React.ElementType;
    text: string;
    link: string;
    itemKey: string;
    children: React.ReactNode;
    onClick?: () => void;
}

const MenuItem: React.FC<Props> = ({ icon, text, link, children, itemKey, onClick }) => {
    const { classes, cx } = useStyles();
    const history = useHistory();
    const { adaptive, active, expanded } = useMenuContext();

    const isExpanded = expanded.includes(itemKey);

    const handleClick = useCallback(
        (event) => {
            event.preventDefault();
            link.startsWith('https') ? window.open(link, '_blank') : history.push(link);
            onClick?.();
        },
        [history, link, onClick]
    );

    return (
        <>
            <a
                href={link}
                className={cx(classes.link, classes.menuItem, {
                    [classes.active]: itemKey === active,
                    [classes.expanded]: isExpanded
                })}
                onClick={handleClick}
            >
                <SvgIcon className={classes.icon} component={icon} />
                <div className={cx(classes.text, { [classes.textAdaptive]: adaptive })}>{text}</div>
            </a>
            {children && <Collapse in={isExpanded}>{children}</Collapse>}
        </>
    );
};

export default MenuItem;
